import React, { useState, useEffect } from "react";

import { validateIsRequired } from "./utils/helpers";

const getGuestConfig = settings => {
	const firstNameValue = settings.guest ? settings.guest["firstName"] : null;
	const lastNameValue = settings.guest ? settings.guest["lastName"] : null;

	const firstNameConfig = {
		label: "First name ",
		$path: `${settings.path}.${settings.index}.firstName`,
		$errors: settings.required ? validateIsRequired(firstNameValue, settings.required) : null,
		type: "text",
		field: "firstName",
		enabled: settings.enabled,
		isRequired: settings.required,
	};

	const middleNameConfig = {
		label: "Middle name ",
		$path: `${settings.path}.${settings.index}.middleName`,
		type: "text",
		field: "middleName",
		enabled: settings.enabled,
		isRequired: false,
	};

	const lastNameConfig = {
		label: "Last name ",
		$path: `${settings.path}.${settings.index}.lastName`,
		$errors: settings.required ? validateIsRequired(lastNameValue, settings.required) : null,
		type: "text",
		field: "lastName",
		enabled: settings.enabled,
		isRequired: settings.required,
	};

	return { firstNameConfig, middleNameConfig, lastNameConfig };
};

export const GuestComponent = ({
	path,
	index,
	guest,
	enabled,
	required,
	bem,
	setContent,
	Components,
	restProps,
}) => {
	const [ guestConfig, setGuestConfig ] = useState();
	const [ firstName, setFirstName ] = useState();
	const [ middleName, setMiddleName ] = useState();
	const [ lastName, setLastName ] = useState();
	const [ mounted, setMounted ] = useState();

	useEffect(() => {
		setFirstName(guest?.firstName ?? null);
		setMiddleName(guest?.middleName ?? null);
		setLastName(guest?.lastName ?? null);
		setMounted(true);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ ]);

	useEffect(() => {
		const config = getGuestConfig({
			path,
			index,
			guest,
			enabled,
			required
		});
		setGuestConfig(config);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [ enabled ]);

	useEffect(() => {
		if (!mounted) {
			return;
		}

		if(firstName !== guest?.firstName) {
			setContent("guest.firstName", firstName);
		}

		if(middleName !== guest?.middleName) {
			setContent("guest.middleName", middleName);
		}

		if(lastName !== guest?.lastName) {
			setContent("guest.lastName", lastName);
		}
	},[ firstName, middleName, lastName ]);

	const key = `${index}-`;

	if(!guestConfig) {
		return null;
	}

	return (
		<>
			<div className={bem(`col--2`)}>
				<Components.text
					{...restProps}
					config={{
						...guestConfig.firstNameConfig,
						$errors: validateIsRequired(firstName, required),
						value: firstName,
					}}
					ckey={`${key}-${guestConfig.firstNameConfig.field}`}
					key={`${key}-${guestConfig.firstNameConfig.field}`}
					onChange={setFirstName}
				/>
			</div>
			<div className={bem(`col--2`)}>
				<Components.text
					{...restProps}
					config={{ ...guestConfig.middleNameConfig, value: middleName }}
					ckey={`${key}-${guestConfig.middleNameConfig.field}`}
					key={`${key}-${guestConfig.middleNameConfig.field}`}
					onChange={setMiddleName}
				/>
			</div>
			<div className={bem(`col--2`)}>
				<Components.text
					{...restProps}
					config={{ 
						...guestConfig.lastNameConfig,
						$errors: validateIsRequired(lastName, required),
						value: lastName }}
					ckey={`${key}-${guestConfig.lastNameConfig.field}`}
					key={`${key}-${guestConfig.lastNameConfig.field}`}
					onChange={setLastName}
				/>
			</div>
		</>
	);
};
